<template>
<v-container app :fluid="true" class="pt-0 pb-0">
    <v-row>
        <v-col cols="8" class="pt-0 pb-0">
            <span class="title">Registro de compra</span>
        </v-col>        
    </v-row>
    <v-row>
        <v-col cols="8" class="pt-0">
            <v-card>
                <v-card-text>
                    <template>
                        <v-row>
                            <v-col cols="6">
                                <v-autocomplete
                                    v-model="value_provider"
                                    :items="providers"
                                    outlined
                                    dense
                                    clearable 
                                    clear-icon="far fa-times-circle"               
                                    label="Proveedor"
                                    persistent-hint
                                    :item-text="customText"
                                    item-value="id"
                                    :filter="customFilter"
                                    hide-details
                                >
                                    <template v-slot:item="data">
                                        <v-list-item-content>                                            
                                            <v-list-item-title>{{ data.item.name }}</v-list-item-title>
                                            <v-list-item-subtitle>RUC: {{ data.item.document }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="6">
                                <v-menu
                                    v-model="menuVoucherDate"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                        v-model="voucher_date"
                                        label="Fecha de comprobante"
                                        readonly
                                        outlined
                                        dense
                                        clearable
                                        v-on="on"
                                        @click:clear="voucher_date=null"
                                        hide-details
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="voucher_date" 
                                        @input="menuVoucherDate = false" 
                                        no-title
                                        locale="es"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>                            
                        </v-row>

                        <v-row>
                            <v-col cols="6">
                                <v-text-field
                                    label="Serie"
                                    v-model="serie"
                                    dense
                                    outlined
                                    hide-details
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field
                                    label="Correlativo"
                                    v-model="correlativo"
                                    dense
                                    outlined
                                    hide-details
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="4">
                                <v-switch
                                    v-model="is_credit"
                                    color="primary"
                                    label="Compra a crédito"
                                    class="mt-0"
                                    hide-details
                                ></v-switch>
                            </v-col>
                            <v-col cols="4" v-if="is_credit">
                                <v-select
                                    :items="term_days"
                                    label="Días de plazo"
                                    v-model="term_days_selected"
                                    dense
                                    outlined
                                    clearable
                                    hide-details
                                    @change="handleSelectTermDays"
                                ></v-select>
                            </v-col>
                            <v-col cols="4" v-if="is_credit">
                                <v-menu
                                    v-model="menuPaymentDate"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="payment_date"
                                            label="Fecha de pago"
                                            dense
                                            outlined
                                            readonly
                                            clearable
                                            hide-details
                                            v-on="on"
                                            @click:clear="payment_date=null"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="payment_date" 
                                        @input="menuPaymentDate = false" 
                                        no-title
                                        locale="es"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                    </template>
                </v-card-text>
            </v-card>

            <v-card class="mt-8">
                <v-card-text>
                    <template>
                        <v-row>                            
                            <v-col cols="12">
                                <v-autocomplete
                                    v-model="value_product"
                                    :items="products"
                                    dense
                                    outlined                                    
                                    label="Producto"
                                    :item-text="customProduct"
                                    item-value="id"
                                    hide-details
                                    clearable
                                    @change="handleSelectProduct"                        
                                ></v-autocomplete>
                            </v-col>                            
                        </v-row>
                        <v-row>
                            <v-col cols="4">
                                <v-text-field v-model="quantity" 
                                    label="Cantidad" 
                                    type="number" 
                                    hide-details
                                    dense
                                    outlined
                                ></v-text-field>
                            </v-col>
                            <v-col cols="4">
                                <v-text-field 
                                    v-model="price" 
                                    label="P. Unitario" 
                                    type="number" 
                                    hide-details
                                    dense
                                    outlined
                                ></v-text-field>
                            </v-col>
                            <v-col cols="4">
                                <v-btn 
                                    block 
                                    @click="handleAddSupply" 
                                    dark 
                                    color="green darken-1">
                                    Añadir
                                </v-btn>
                            </v-col>
                        </v-row>
                            
                    </template>
                </v-card-text>
            </v-card>
        </v-col>

        <v-col cols="4" class="pt-0">
            <v-card>
                <v-card-title class="pt-1 pb-1">
                    <span class="subtitle-2">Detalle de compra</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-0 list-items-purchase">
                    <template>
                        <v-row>
                            <v-col cols="12">
                                <v-list-item v-for="(item, index) in itemsSelected" :key="item.id" class="cart-item-product pl-0 pr-0" two-line flat>
                                    <template>                                
                                        <v-list-item-content>
                                            <v-list-item-title class="product-name">
                                                {{ item.name }}
                                            </v-list-item-title>
                                            <v-list-item-subtitle class="product-price">
                                                <span class="ml-2">{{ item.price | currency('S/') }}</span>
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action class="btn-quantity">
                                            <span class="ml-4 mr-4 pb-1 product-quantity">{{ item.quantity }}</span>
                                            <v-icon class="ml-1" color="red" @click="handleRemoveItem(index)">
                                                far fa-times-circle
                                            </v-icon>
                                        </v-list-item-action>
                                    </template>
                                </v-list-item>
                            </v-col>
                        </v-row>
                    </template>
                </v-card-text>
            </v-card>

            <v-card class="mt-3">
                <v-card-text class="pt-0 pb-0">
                    <template>
                        <v-row>
                            <v-col cols="6">
                                <span>Subtotal</span>
                            </v-col>
                            <v-col cols="6" class="text-right">
                                <span>{{ subtotal_purchase | currency('S/') }}</span>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6">
                                <span>Igv</span>
                            </v-col>
                            <v-col cols="6" class="text-right">
                                <span>{{ igv_purchase | currency('S/') }}</span>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6">
                                <span>Total</span>
                            </v-col>
                            <v-col cols="6" class="text-right">
                                <span>{{ total_purchase | currency('S/') }}</span>
                            </v-col>
                        </v-row>
                    </template>
                </v-card-text>
            </v-card>

            <div class="mt-3">
                <template>
                    <v-row>
                        <v-col cols="6" class="pt-0 pb-0">            
                            <v-btn block
                                color="red"
                                dark
                                @click="handleCancel">
                                Cancelar
                            </v-btn>
                        </v-col>
                        <v-col cols="6" class="pt-0 pb-0" >            
                            <v-btn block 
                                dark 
                                color="primary"
                                :disabled="press_button" 
                                @click="handleSavePurchase"
                                v-if="verifyPermission('registrar_compras')">
                                Guardar Compra
                            </v-btn>
                        </v-col>
                    </v-row>
                </template>
            </div>
        </v-col>
    </v-row>
</v-container>
    
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

import Tools from '../../helpers/Tools.js'

import {APIService} from '@/APIService';
const apiService = new APIService();

export default {
    name: 'Purchases',
    data(){
        return {
            type_selected: 'Producto',
            value_provider: '',
            serie: '',
            correlativo: '',
            voucher_date: '',
            menuVoucherDate: false,
            is_credit: false,
            term_days: [15, 30, 60, 90],
            term_days_selected: '',
            payment_date: '',
            menuPaymentDate: false,
            quantity: '',
            price: '',
            values: '',
            supply_selected: null,
            product_selected: null,
            value_product: null,
            itemsSelected: [],
            subtotal_purchase: 0,
            igv_purchase: 0,
            total_purchase: 0,
            press_button: false
        }
    },
    computed: {
        ...mapState('provider', [
            'providers'
        ]),
        ...mapState('production', [
            'supplies'
        ]),
        ...mapState('products', [
            'products'
        ])
    },
    methods: {
        ...mapActions('provider', [
            'getProviders'
        ]),
        ...mapActions('production', [
            'getSupplies'
        ]),
        ...mapActions('products', [
            'getAllProducts'
        ]),
        customText(item){
            let text = item.name
            
            return text
        },
        customProduct(item){
            let text = item.description;
            
            return text
        },
        customFilter(item, queryText, itemText) {
            const textName = item.name.toLowerCase()
            const textDocument = item.document.toLowerCase()
            const searchText = queryText.toLowerCase()

            return textName.indexOf(searchText) > -1 || textDocument.indexOf(searchText) > -1
        },
        handleSelectSupply(value){
            this.supply_selected = value
        },
        handleSelectProduct(value) {
            this.product_selected = value;
        },
        handleAddSupply(){
            let today = new Date();
            let item_id = null;
            let data = null;
            
            item_id = this.product_selected;
            if(item_id && this.quantity > 0 && this.price > 0){
                data = Tools.getItemFromList(this.products, item_id);
                
                let item = {
                    id: today.getTime(),
                    type: this.type_selected.toLowerCase(),
                    item_id: data.id,
                    name: data.description,
                    quantity: this.quantity,
                    price: this.price,
                    subtotal: this.quantity * this.price
                }

                this.itemsSelected.push(item)
                this.calculatePrices();
                this.clearDataSelected();
            }
        },
        handleRemoveItem (index) {
            this.itemsSelected.splice(index, 1);
            this.calculatePrices();
        },
        clearDataSelected() {
            this.values = '';
            this.value_product = '';
            this.supply_selected = null;
            this.product_selected = null;
            this.quantity = null;
            this.price = null;
        },
        calculatePrices(){
            let amount_subtotal = 0
            let amount_igv = 0
            let amount_total
            this.itemsSelected.forEach((element) => {
                let subtotal_item = element.price * element.quantity
                let amount_without_igv = subtotal_item / 1.18
                amount_subtotal = amount_subtotal + amount_without_igv
                amount_igv = amount_igv + ( amount_without_igv * 0.18 )
            })

            this.subtotal_purchase = amount_subtotal
            this.igv_purchase = amount_igv
            this.total_purchase = this.subtotal_purchase + this.igv_purchase
        },
        handleSelectTermDays(value){
            if(this.term_days_selected){
                let sum = this.term_days_selected + " days"
                let currentDate = new Date()
                currentDate.setDate(currentDate.getDate() + this.term_days_selected)
                currentDate = this.convertDate(currentDate)
                this.payment_date = currentDate
            } else {
                this.payment_date = ''
            }
        },
        convertDate(date) {
            let year = date.getFullYear()
            let month = date.getMonth() + 1
            let day = date.getDate()

            if(month < 10) {
                month = '0' + month
            }
            if(day < 10) {
                day = '0' + day
            }

            let newDate = year + '-' + month + '-' + day
            return newDate
        },
        handleSavePurchase(){
            this.press_button = true;
            let is_paid = true
            if(this.is_credit) {
                is_paid = false
            }
            let purchase = {
                provider_id: this.value_provider,
                voucher_date: this.voucher_date,
                serie: this.serie,
                correlative: this.correlativo,
                is_credit: this.is_credit,
                term_days: this.term_days_selected,
                payment_date: this.payment_date,
                subtotal: this.subtotal_purchase,
                igv: this.igv_purchase,
                total: this.total_purchase,
                detail: this.itemsSelected,
                is_paid: is_paid
            }
            
            if(this.validate(purchase)){
                apiService.createPurchases(purchase).then( (response) => {
                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        title: 'RESULTADO DE REGISTRO DE COMPRA',
                        text: 'La compra se registró de manera exitosa!'
                    });
                    this.press_button = false;
                    this.clearData()
                }).catch((error) => {
                    this.press_button = false;
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: 'RESULTADO DE REGISTRO DE COMPRA',
                        text: 'Se detectó un error al registrar la compra!'
                    })
                })
            } else{
                this.press_button = false;
                this.$notify({
                    group: 'foo',
                    type: 'error',
                    title: 'RESULTADO DE REGISTRO DE COMPRA',
                    text: 'Debe ingresar los datos de compra!'
                })
            }
            
        },
        clearData(){
            this.value_provider = ''
            this.voucher_date = ''
            this.serie = ''
            this.correlativo = ''
            this.is_credit = false
            this.term_days_selected = ''
            this.payment_date = ''
            this.subtotal_purchase = ''
            this.igv_purchase = ''
            this.total_purchase = ''
            this.itemsSelected = []
        },
        validate(purchase){
            let is_valid = true
            if(!purchase.provider_id){
                is_valid = false
            }
            if(!purchase.voucher_date){
                is_valid = false
            }
            if(!purchase.serie || purchase.serie == ''){
                is_valid = false
            }
            if(!purchase.correlative || purchase.correlative == ''){
                is_valid = false
            }
            if(purchase.is_credit){
                if(!purchase.term_days){
                    is_valid = false
                }
                if(!purchase.payment_date){
                    is_valid = false
                }
            }
            if(purchase.detail.length <= 0) {
                is_valid = false
            }

            return is_valid
        },
        verifyPermission(permission) {
            return this.$hasPermision(permission)
        },
        handleCancel () {
            this.clearData();
        }
    },
    created () {
        this.getProviders();
        this.getSupplies();
        this.getAllProducts({
            show_catalogue: 'si'
        });
    },
    mounted() {
        this.clearData();
    }
}
</script>

<style>
.list-items-purchase{
    height: 50vh;
    overflow-y: auto;
}
</style>